<template>
	<div class="element asset-element">
		<label v-if="label" :for="name" :class="labelClass">
			{{ label }}
			<span v-if="validate">*</span>
		</label>
		<div class="asset-selector" :class="classname">
			<div class="thumbnail">
				<template v-if="!!selected">
					<img v-if="selected.type == 'IMAGE' && thumbnail" :src="thumbnail" :alt="selected.name"/>
					<icon v-else :icon="selected.type.toLowerCase()" class="icon"/>
				</template>
			</div>
			<div class="selection-wrap">
				<div v-if="selected" class="selection">
					<div class="name">{{ selected.name }}</div>
					<div class="file">{{ selected.file }}</div>
					<a
						v-if="showViewButton"
						:href="selected.url"
						target="_blank"
						class="btn btn-info"
					>
						View
					</a>
					<button class="btn btn-danger" @click.prevent="remove">Remove</button>
				</div>
				<div v-else class="browse">
					<p class="mb-2">Choose a file from the Asset Library</p>
					<button class="btn btn-info" @click.prevent="browse">Browse</button>
				</div>
			</div>
			<input type="hidden" :name="name" :value="selectedId"/>
		</div>
		<div v-if="errorText" class="invalid-feedback" v-html="errorText"></div>
		<div
			v-else
			v-for="(error, i) in errors.collect(name)"
			:key="i"
			class="invalid-feedback"
		>{{ error }}
		</div>
		<div v-if="helpText" class="help-text" v-html="helpText"></div>
	</div>
</template>

<script>
import AssetBrowser from "./AssetBrowser";
import InputFieldProps from "mixins/InputFieldProps";
import HelpModal from "../layout/partials/HelpModal.vue";

export default {
	inject: ["$validator"],
	mixins: [InputFieldProps],
	components: {AssetBrowser, HelpModal},
	props: {
		types: {type: Array, default: () => []},
		value: {},
		showViewButton: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			selected: null,
		};
	},
	computed: {
		classname() {
			return this.types.length == 1 ? this.types[0] : "";
		},
		selectedId() {
			return this.selected ? this.selected.id : null;
		},
		thumbnail() {
			return this.selected ? this.selected.thumbnail : null;
		},
		isSvgThumbnail() {
			return this.thumbnail
				? this.thumbnail.search("/images/svg/") !== -1
				: false;
		},
	},
	watch: {
		value(val) {
			if (!val) {
				this.remove();
			} else if (_.isObject(val)) {
				this.selected = val;
			} else {
				this.load(val);
			}
		},
		selected(val) {
			this.$emit("input", val);
		},
	},
	methods: {
		browse() {
      // this.$modal(HelpModal, {})
			this.$modal(AssetBrowser, {
				types: this.types,
			})
				.then((selected) => {
					this.selected = selected;
				})
				.catch(() => {
				});
		},
		load(id) {
			this.axios
				.get(this.route("asset.show", {asset: id}))
				.then((response) => {
					this.selected = response.data;
				});
		},
		remove() {
			this.selected = null;
		},
	},
	mounted() {
		if (this.value && _.isObject(this.value)) {
			this.selected = this.value;
		} else if (!!this.value && parseInt(this.value, 10) > 0) {
			this.load(this.value);
		}
	},
};
</script>
